var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"header"},[_c('a',{attrs:{"href":"/"}},[_vm._v("ＬＥＣ ＣＢＴ試験 ")]),_c('hr',{staticClass:"m-0"})])
}]

export { render, staticRenderFns }